import { STATE_RECORD_FULL_NAME_MAPPER_WITHOUT_SHORT } from "@/constants";
import {
  NOTE_PREVIEW_PHARMACY_FAX_PREFIX,
  NOTE_PREVIEW_PHARMACY_PHONE_PATTERN,
  NOTE_PREVIEW_STATE_ID_PATTERN,
  NOTE_PREVIEW_ZIP_PATTERN,
} from "./note-preview-constant";
import { splitIntoSentences } from "./note-preview-line-utils";
import { NotePreviewPharmacy } from "./note-preview-types";

/** "name, (191) 755-5852, fax 3454, Pune, addr 2, 123456, US" → name, phone, fax and the rest as the address. */
export const parsePharmacy = (text: string): NotePreviewPharmacy => {
  const [name = "", ...rest] = text.split(",").map((part) => part.trim());
  const phone = rest.find((part) =>
    NOTE_PREVIEW_PHARMACY_PHONE_PATTERN.test(part)
  );
  const faxPart = rest.find((part) =>
    NOTE_PREVIEW_PHARMACY_FAX_PREFIX.test(part)
  );
  const addressParts = rest.filter(
    (part) => part && part !== phone && part !== faxPart
  );
  // Notes signed before the form mapped states carry the state id just ahead of the zip code.
  const address = addressParts
    .map((part, index) =>
      NOTE_PREVIEW_STATE_ID_PATTERN.test(part) &&
      NOTE_PREVIEW_ZIP_PATTERN.test(addressParts[index + 1] ?? "")
        ? (STATE_RECORD_FULL_NAME_MAPPER_WITHOUT_SHORT[part] ?? part)
        : part
    )
    .join(", ");
  return {
    name,
    phone,
    fax: faxPart?.replace(NOTE_PREVIEW_PHARMACY_FAX_PREFIX, ""),
    address,
  };
};

/** One pharmacy per sentence of the line. */
export const parsePharmacies = (text: string): NotePreviewPharmacy[] =>
  splitIntoSentences(text).map(parsePharmacy);
